<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="visible"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="handleClose()"
           [style]="{width:'750px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div style="color: #333333;">Create new employee</div>
            <div style="font-size: 14px; color: #333333; font-weight: 600;">For {{typeCreatedEmployee === typesMerchantEmployee.StoreEmployees ? 'store' : 'web admin'}} employee</div>
        </div>
    </ng-template>

    <hr *ngIf="!showStepCreate" class="hr-line" />

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                       [styleClass]="'app-scrollpanel'">
            <div class="flex flex-row" *ngIf="!showStepCreate" style="margin-top: 20px;">
                <div class="create-employee-type-item" [ngClass]="{'create-employee-type-item-selected': selectedCreationFormat === employeeCreationFormatEnum.Individual}"
                     (click)="handleChangeTypeCreatedEmployee(employeeCreationFormatEnum.Individual)">
                    <div class="flex flex-row">
                        <img class="create-employee-icon" src="/XpressApp/assets/images/merchant/create-individual-employee.png" />
                        <div style="margin-top: 22px; color: #333333; ">Create individual employee</div>
                    </div>
                </div>
                <div class="create-employee-type-item" [ngClass]="{'create-employee-type-item-selected': selectedCreationFormat === employeeCreationFormatEnum.Multiple}"
                     (click)="handleChangeTypeCreatedEmployee(employeeCreationFormatEnum.Multiple)">
                    <div class="flex flex-row">
                        <img class="create-employee-icon" src="/XpressApp/assets/images/merchant/upload-multiple-employee.png" />
                        <div>
                            <div style="margin-top: 16px; color: #333333; ">Upload multiple employee</div>
                            <div style="color: #333333; opacity: 0.5; font-size: 8px;">Upload multiple employee via CSV file</div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedCreationFormat === employeeCreationFormatEnum.Multiple && !showStepCreate">
                <div class="employee-upload-description-block">
                    <div class="employee-upload-description-block__title" style="margin-bottom: 20px">Upload CSV File</div>
                    <div class="flex flex-row">
                        <input maxlength="0" pInputText type="text" (click)="handleInputClick('idFileInput')" class="p-inputtext-sm download-template-empl-input-field" placeholder="Upload CSV file" />
                        <p-button icon="pi pi-upload" (click)="handleInputClick('idFileInput')"></p-button>
                    </div>

                    <input id="idFileInput"
                           type="file"
                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                           style="display: none"
                           (change)="handleXlsChange($event)" required />
                </div>

                <div class="download-template-empl-block" (click)="downloadTemplate()">
                    <div class="download-template-empl-icon">
                        <img src="/XpressApp/assets/images/product/csv.svg" />
                    </div>
                    <div class="download-template-empl-title">
                        Download template
                    </div>
                </div>
            </div>
            <div *ngIf="showStepCreate && selectedCreationFormat === employeeCreationFormatEnum.Individual">
                <div class="bg-menu">
                    <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[activeTab-1]"></p-tabMenu>
                </div>
                <div *ngIf="activeTab === menuTab.EmployeeDetail" class="menu-item-body">
                    <div style="color: #272D3B; font-size: 18px; margin-bottom: 15px;">Personal Information</div>
                    <div class="flex flex-row" style="margin-bottom: 20px;">
                        <div style="padding: 36px; align-items: center; justify-content: center; display: flex">
                            <div *ngIf="employee.ImageUrl && !showEditFields" style="background-image: url({{employee.ImageUrl}});" class="image-filled"></div>
                            <div *ngIf="employee.ImageUrl && showEditFields" style="background-image: url({{employee.ImageUrl}}); cursor: pointer" (click)="handleInputClick('idImgInput')" class="image-filled"></div>
                            <div *ngIf="!employee.ImageUrl && showEditFields" (click)="handleInputClick('idImgInput')" style="background: #F2F5F7; width: 100px; height: 100px; border-radius: 50%; align-items: center; justify-content: center; display: flex; cursor: pointer">
                                <div style="color: #004060;">
                                    <i style="font-size: 25px; margin-left: 10px; font-weight: 700;" class="pi pi-upload"></i>
                                    <div>Upload</div>
                                </div>
                            </div>
                            <div *ngIf="!employee.ImageUrl && !showEditFields" style="background: #F2F5F7; width: 100px; height: 100px; border-radius: 50%; align-items: center; justify-content: center; display: flex;">
                                <div style="color: #004060;">
                                    <i style="font-size: 25px; margin-left: 10px; font-weight: 700;" class="pi pi-upload"></i>
                                    <div>Upload</div>
                                </div>
                            </div>
                            <input id="idImgInput"
                                   type="file"
                                   accept="image/*"
                                   style="display: none"
                                   (change)="handleImageChange($event)" required />
                        </div>
                        <div>
                            <div class="flex flex-row">
                                <div>
                                    <div class="employee-input-label">First Name</div>
                                    <input pInputText type="text" [disabled]="!showEditFields" [(ngModel)]="employee.FirstName" placeholder="First Name" class="employee-input-field input-name italic" />
                                </div>
                                <div style="margin-left: 20px;">
                                    <div class="employee-input-label">Last Name</div>
                                    <input [disabled]="!showEditFields" class="employee-input-field input-name italic" type="text" [(ngModel)]="employee.LastName" placeholder="Last Name" pInputText />
                                </div>
                            </div>

                            <div class="employee-input-label">Home Address <a style=" color: #272D3B; font-size: 14px; font-weight: 300;">(optional)</a></div>
                            <p-autoComplete [(ngModel)]="employee.Address"
                                            [suggestions]="addresses"
                                            (completeMethod)="search($event)"
                                            placeholder="Search Google Maps"
                                            [inputStyle]="{'width': '420px', 'height': '47px', 'border': '0.5px solid rgba(0, 64, 96, 0.3019607843)'}"
                                            [disabled]="!showEditFields">
                            </p-autoComplete>
                        </div>
                    </div>

                    <div class="flex flex-row">
                        <div style="margin-right: 30px; width: 290px;">
                            <div class="employee-input-label">Date of Birth</div>
                            <p-calendar [inputStyle]="{'border-radius': '6px', 'border': '0.5px solid rgba(0, 64, 96, 0.3019607843)', 'width': '275px', 'height': '47px'}"
                                        class="employee-input-field input-min" placeholder="mm/dd/yyyy" [(ngModel)]="employee.Birthday" [disabled]="!showEditFields"></p-calendar>

                            <div class="employee-input-label" style="margin-top: 20px;">Cellphone Number</div>
                            <input [disabled]="!showEditFields" class="employee-input-field input-min italic" type="text" [(ngModel)]="employee.Phone" placeholder="+63" pInputText />
                        </div>

                        <div>
                            <div class="employee-input-label">Company ID <a style=" color: #272D3B; font-size: 14px; font-weight: 300;">(optional)</a></div>
                            <input [disabled]="!showEditFields" class="employee-input-field input-min italic" type="text" [(ngModel)]="employee.ExternalId" placeholder="Employee ID" pInputText />

                            <div class="employee-input-label">Company Email</div>
                            <input [disabled]="!showEditFields" class="employee-input-field input-min italic" type="text" [(ngModel)]="employee.Email" placeholder="Email" pInputText />
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === menuTab.Role" class="menu-item-body">
                    <div class="employee-input-label">Select Role</div>
                    <p-dropdown [disabled]="!showEditFields" [options]="typeCreatedEmployee === typesMerchantEmployee.StoreEmployees ? storeRoles : adminRoles"
                                [(ngModel)]="employee.RoleId" placeholder="Select" optionLabel="name" optionValue="id" [style]="{width: '300px'}"></p-dropdown>

                    <div class="employee-input-label" style="margin-top: 20px;">Role Permissions</div>

                    <div style="background-color: #F2F5F780; border: 0.5px solid #0040604D; border-radius: 10px; padding: 15px; ">
                        <div class="flex flex-row">
                            <div [style.width.px]="typeCreatedEmployee === typesMerchantEmployee.StoreEmployees ? 190 : 110"></div>
                            <div *ngFor="let role of typeCreatedEmployee === typesMerchantEmployee.StoreEmployees ? storeRoles : adminRoles" class="tab-text-color tab-width-column">{{ role.name }}</div>
                        </div>
                        <div *ngFor="let group of groupedRoleRights; let last = last">
                            <div>
                                <div class="tab-groupname tab-text-color" [style.width.px]="typeCreatedEmployee === typesMerchantEmployee.StoreEmployees ? 190 : 110">{{ group.GroupName }}</div>
                                <div *ngFor="let action of group.Actions">
                                    <div class="flex flex-row">
                                        <div class="tab-displayname tab-text-color" [style.width.px]="typeCreatedEmployee === typesMerchantEmployee.StoreEmployees ? 190 : 110">{{ action.DisplayName }}</div>
                                        <div class="flex flex-row" *ngFor="let role of typeCreatedEmployee === typesMerchantEmployee.StoreEmployees ? storeRoles : adminRoles">
                                            <div style="position: relative;" class="tab-width-column" *ngIf="hasPermission(action, role.id)"><img class="tab-icon" src="/XpressApp/assets/images/tab-create-employee-yes.png" /></div>
                                            <div style="position: relative;" class="tab-width-column" *ngIf="!hasPermission(action, role.id)"><img class="tab-icon" src="/XpressApp/assets/images/tab-create-employee-no.png" /></div>
                                        </div>
                                    </div>
                                </div>
                                <hr *ngIf="!last" style="margin: 0px 1px -10px 1px;" class="hr-filter" />
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === menuTab.Location" class="menu-item-body">
                    <div class="employee-input-label" style="margin-bottom: 35px; width: 85%;">You may assign employees to multiple locations, however they can ONLY login to one location at a time.</div>
                    <div class="employee-input-label">Assign to Location:</div>
                    <p-dropdown [disabled]="!showEditFields" [(ngModel)]="employee.StoreId" (onChange)="addStoreToUser($event)" [style]="{'width':'300px'}"
                                [options]="stores" placeholder="Search Location" optionLabel="Name" optionValue="Id" [showClear]="false"></p-dropdown>

                    <div *ngIf="employee.Store" style="margin-top: 20px;">
                        <div class="flex flex-row" style="width: 360px; height: 115px; box-shadow: 0px 3px 6px #3333331A; border: 0.5px solid #0040604D; border-radius: 10px; padding: 11px;">
                            <img [src]="employee.Store.ImageUrl" style="width: 90px; height: 90px; border-radius: 5px; margin-right: 15px;" />
                            <div style="width: 90%">
                                <div style="font-size: 16px; color: #272D3B; margin-top: 20px;">{{employee.Store.Name}}</div>
                                <div style="font-size: 10px; color: #272D3B; margin-top: 5px">{{employee.Store.Address}}</div>
                            </div>
                            <div *ngIf="showEditFields">
                                <p-menu appendTo="body" #menu [model]="menuEditLocationItems" [popup]="true"></p-menu>
                                <button style="margin-left: auto; color: #000000; border: none; background: none" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === menuTab.Email && isCreateEmployee" class="menu-item-body">
                    <div class="employee-input-label" style="margin-bottom: 55px; width: 80%;">Email credentials to the employee’s designated email now or at a scheduled date & time.</div>
                    <div class="employee-input-label">Send Email:</div>
                    <div class="flex flex-row">
                        <p-dropdown [style]="{'width': '200px'}" [(ngModel)]="selectedSendMailDelay" [options]="sendMailDelay" placeholder="Select" optionLabel="name" [showClear]="false"></p-dropdown>
                        <div style="width: 200px; margin-left: 20px;" *ngIf="selectedSendMailDelay && selectedSendMailDelay.showCustom">
                            <p-calendar [(ngModel)]="customSendMailDateTime" [showTime]="true" [showSeconds]="true"></p-calendar>
                        </div>
                    </div>

                </div>
            </div>
            <div *ngIf="showStepCreate && selectedCreationFormat === employeeCreationFormatEnum.Multiple">
                <div class="upload-multiply-employee-bold-text" style="margin: 20px 0px;">Preview Upload</div>

                <div style="background-color: #F2F5F7; border: 0.5px solid #0040604D; border-radius: 10px; padding: 20px; ">
                    <div style="color: #272D3B; font-size: 16px;" class="upload-multiply-employee-text">{{totalUploadedEmployeesCount}} Total Records</div>
                    <div class="flex flex-row">
                        <div class="upload-multiply-employee-success-text upload-multiply-employee-text">Successfully uploaded:</div>
                        <div class="upload-multiply-employee-bold-text">{{successUploadedEmployeesCount}}</div>
                    </div>
                    <div class="flex flex-row">
                        <div class="upload-multiply-employee-error-text upload-multiply-employee-text">
                            Failed or has errors:
                        </div>
                        <div class="upload-multiply-employee-bold-text">
                            {{errorUploadedEmployeesCount}}
                        </div>
                        <div *ngIf="errorUploadedEmployeesCount > 0" (click)="saveUnuploadedEmployees()"
                             style="margin-left: 60px; cursor: pointer; color: #00C0F0" class="flex flex-row">
                            <i class="pi pi-cloud-download" style="font-size: 1.4rem"></i>
                            <div style="margin-left: 10px;">Download</div>
                        </div>
                    </div>
                </div>
            </div>
        </p-scrollPanel>
        <hr class="hr-filter" />
        <div class="flex justify-content-end mrg-10-0px">
            <button *ngIf="selectedCreationFormat === employeeCreationFormatEnum.Individual && !showStepCreate" class="btn-darkblue" (click)="showStepCreate=true;" pButton label="Next"></button>
            <button *ngIf="activeTab === menuTab.Email" class="btn-darkblue" (click)="createMerchantUser()" pButton label="Create"></button>
            <button *ngIf="showEditFields && !isCreateEmployee" class="btn-darkblue" (click)="updateMerchantUser()" pButton label="Save"></button>
        </div>
    </div>

</p-sidebar>
